import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsLookupParams,
  GetMarathonsLookupResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";
import { List } from "entities/admin/model/slice/types";

export const getMarathonsLookup = createAsyncThunk<
  List<GetMarathonsLookupResponse>,
  GetMarathonsLookupParams
>("marathons/getMarathonsLookup", async (params, { rejectWithValue }) => {
  try {
    const data = await MarathonsAPI.getMarathonsLookup(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting marathons lookup", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting marathons lookup", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
